<template>
  <section
    :class="sectionBgClass"
    class="w-full overflow-hidden"
  >
    <div :class="[data?.containerFull ? 'w-full' : 'container px-0 lg:px-4']">
      <!-- title -->
      <UiHeading
        v-if="data?.heading"
        :pin="data?.heading?.pin"
        :title="data?.heading?.title"
        :description="data?.heading?.description"
        :button="data?.heading?.button"
        :color="data?.heading?.color"
        :position="data?.heading?.position"
        v-aos="animate && 'zoom-out'"
      />
      <!-- title -->

      <!-- Card -->
      <!-- Slider -->
      <template v-if="shouldShowSlider">
        <div v-aos="animate && 'fade-up'" class="w-full">
          <PluginsCarousel
            :data="enabledItems"
            :pagination="true"
            :navigation="false"
            :per="data?.column === 'column-4' ? 4 : 3"
            type="Card"
            class="cards-slider"
            :class="carouselClass"
          >
            <template v-slot="{ slide }">
              <UiCardDefault
                :pin="slide?.pin"
                :title="slide?.title"
                :description="slide?.description"
                :link="slide?.link"
                :button="slide?.button"
                :media="slide?.media"
                :position="data?.position"
                :mediaSize="data?.mediaSize"
                :background="data?.backgroundColor"
                :objectFit="data?.objectFit"
                class="h-full"
              />
            </template>
          </PluginsCarousel>
        </div>
      </template>
      <!-- Slider -->

      <!-- Non Slider -->
      <template v-else>
        <div
          v-aos="animate && 'fade-up'"
          class="grid grid-cols-1 gap-6"
          :class="gridColumnClass"
        >
          <template v-for="(item, index) in enabledItems">
            <UiCardDefault
              :pin="item?.pin"
              :title="item?.title"
              :description="item?.description"
              :link="item?.link"
              :button="item?.button"
              :media="item?.media"
              :position="data?.position"
              :mediaSize="data?.mediaSize"
              :objectFit="data?.objectFit"
              :background="data?.backgroundColor"
            />
          </template>
        </div>
      </template>
      <!-- Non Slider -->
      <!-- Card -->

      <!-- Button -->
      <div
        v-if="data?.showMoreLink && data?.showMoreLink?.length > 0"
        class="flex mt-4 md:mt-6 lg:mt-8 xl:mt-10 justify-center"
      >
        <AtomsButton
          :label="$t('Show More')"
          :link="data?.showMoreLink"
          :color="buttonColor"
          size="medium"
          :enabled="true"
        />
      </div>
      <!-- Button -->
    </div>
  </section>
</template>
<script setup>
import { computed } from "vue";
import { useIsMobile } from "~/composables/utils";
import { sectionOuterSpacingClass } from "~/composables/sectionSpacing";
const props = defineProps({
  data: { type: Object },
  animate: { type: Boolean, default: false },
});

const { isMobile } = useIsMobile();

const sectionBgClass = computed(() => {
  let bg = '';
  const bgColor = props.data?.backgroundColor;
  if (bgColor === 'first') bg = 'bg-brand-first' + (props.data?.backgroundColor !== 'transparent' ? ' py-10 lg:py-20' : '');
  else if (bgColor === 'second') bg = 'bg-brand-second' + (props.data?.backgroundColor !== 'transparent' ? ' py-10 lg:py-20' : '');
  else if (bgColor === 'third') bg = 'bg-brand-third' + (props.data?.backgroundColor !== 'transparent' ? ' py-10 lg:py-20' : '');
  else if (bgColor === 'dark-first') bg = 'bg-brand-dark' + (props.data?.backgroundColor !== 'transparent' ? ' py-10 lg:py-20' : '');
  else if (bgColor === 'dark-second') bg = 'bg-brand-dark-second' + (props.data?.backgroundColor !== 'transparent' ? ' py-10 lg:py-20' : '');
  else if (bgColor === 'light-first') bg = 'bg-brand-light' + (props.data?.backgroundColor !== 'transparent' ? ' py-10 lg:py-20' : '');
  else if (bgColor === 'light-second') bg = 'bg-brand-light-second' + (props.data?.backgroundColor !== 'transparent' ? ' py-10 lg:py-20' : '');
  return [bg, sectionOuterSpacingClass(props.data)];
});

const carouselClass = computed(() => {
  const bg = props.data?.backgroundColor;
  return (bg === 'first' || bg === 'second' || bg === 'dark-first' || bg === 'dark-second') ? '' : 'non-bg';
});

const gridColumnClass = computed(() => props.data?.column === 'column-4' ? 'md:grid-cols-2 xl:grid-cols-4' : 'lg:grid-cols-3');

const buttonColor = computed(() => props.data?.heading?.color === 'white' ? 'white-outline' : 'black-outline');

const shouldShowSlider = computed(() => {
  return props.data?.slider || isMobile.value;
});

const enabledItems = computed(() => props.data?.items?.filter(item => item.enabled) || []);
</script>
